import React from "react";
import GestorVirtualTable from "../components/GestorVirtualTable";
import Layout from "../components/Layout";
const GestorVirtual = () => {
  return (
    <>
      <Layout/>
      <div>
        <GestorVirtualTable />
      </div>
    </>
  );
};

export default GestorVirtual;
